import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { KnowledgeBaseWidgetComponent } from './components/knowledge-base-widget/knowledge-base-widget.component';
import { KnowledgeBaseButtonComponent } from './components/knowledge-base-button/knowledge-base-button.component';
import { KnowledgeBaseService } from './services/knowledge-base.service';
import { CompanyService } from '../_services/company.service';

@NgModule({
  declarations: [
    KnowledgeBaseWidgetComponent,
    KnowledgeBaseButtonComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule
  ],
  providers: [
    KnowledgeBaseService,
    CompanyService
  ],
  exports: [
    KnowledgeBaseWidgetComponent,
    KnowledgeBaseButtonComponent
  ]
})
export class KnowledgeBaseModule { }

